<template>
  <DefaultPage>
    <div class="defense">
      <div class="hero hero-tall">
        <img class="line line-purple-top" src="~@/assets/line-purple-top.png" alt=""/>
        <div class="hero-flex-wrap">
          <div class="grid-container">
            <div class="grid-x grid-margin-x align-middle">
              <div class="cell large-6">
                <div class="hero__call">
                  <h1
                    class="hero__headline__small"
                    data-aos="fade-right"
                    data-aos-duration="1000"
                  >
                    A Strong Legal Defense
                  </h1>
                  <div
                    class="hero__call__content"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <p>Our in-house attorneys collaborate with local defense
                      attorneys and are always at the ready to help you be
                      prepared for what lies ahead. Hear from our very
                      experienced, highly-qualified staff who have your best
                      interests at heart.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="orbs-bg">
        <div
          class="orb purple"
          style="top: 50px; left: -200px;"
        ></div>
        <section>
          <div class="grid-container">
            <p
              class="defense__tagline"
              data-aos="fade-in"
              data-aos-offset="400"
            >
                What does a strong legal defense mean to you?
            </p>
          </div>
        </section>
      </div>
      <template
        v-for="(quote, index) in $quotes"
      >
        <div :key="quote.name">
          <div class="orbs-bg">
            <template v-if="index === 1">
              <div
                class="orb blue"
                style="top: 50px; right: -300px"
              ></div>
              <div class="line line-blue-defense-mid">
                <img
                  style="transform: rotate(10deg) scaleX(1.2) translateX(-50px); transform-origin: center;"
                  src="~@/assets/line-blue-long-swoop-top.png"
                  alt=""
                />
              </div>
            </template>
            <section
              class="quote-section"
              :class="{ 'quote-section--last' : index === $quotes.length - 1 }"
            >
              <div
                class="quote"
                :class="{ 'quote--reversed' : index % 2 > 0 }"
              >
                <div class="grid-container">
                  <div class="grid-x grid-margin-x medium-up-2 align-center">
                    <div
                      class="cell"
                      :class="{ 'medium-order-2' : index % 2 > 0 }"
                      :data-aos="index % 2 > 0 ? 'fade-left' : 'fade-right'"
                      data-aos-duration="600"
                      data-aos-offset="400"
                    >
                      <div class="quote-photo">
                        <div class="quote-photo__double-quote">
                          &ldquo;
                        </div>
                        <div
                          class="quote-photo__photo"
                          data-slider-photos
                        >
                          <img :src="quote.photo" />
                        </div>
                      </div>
                    </div>
                    <div
                      class="cell"
                      :class="{ 'medium-order-1' : index % 2 > 0 }"
                      :data-aos="index % 2 > 0 ? 'fade-right' : 'fade-left'"
                      data-aos-delay="200"
                      data-aos-duration="600"
                      data-aos-offset="400"
                    >
                      <div class="quote-content">
                        <div class="quote-content__author">
                          {{ quote.name }}<br/>{{ quote.position }}
                        </div>
                        <div class="quote-content__quotation">
                          &ldquo;{{ quote.quote }}&rdquo;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="orbs-bg">
            <img
              v-if="index === $quotes.length - 1"
              class="line line-blue-defense-end"
              src="~@/assets/line-blue-long-swoop-top.png"
              alt=""
            />
            <section
              class="stat-section"
              :class="{ 'stat-section--last' : index === $quotes.length - 1 }"
              data-aos="fade-in"
              data-aos-offset="200"
            >
              <div
                class="stat"
                :class="{ 'stat--reversed' : index % 2 > 0 }"
              >
                <div class="grid-container">
                  <div class="grid-x grid-margin-x medium-up-2 align-middle">
                    <div
                      class="cell"
                      :class="{ 'medium-order-2' : index % 2 === 0 }"
                      data-aos="fade-in"
                      data-aos-duration="600"
                      data-aos-offset="200"
                    >
                      <div class="stat-graphic">
                        <img :src="quote.statistic.graphic" />
                      </div>
                    </div>
                    <div
                      class="cell"
                      :class="{ 'medium-order-1' : index % 2 === 0 }"
                      data-aos="fade-in"
                      data-aos-delay="200"
                      data-aos-duration="600"
                      data-aos-offset="200"
                    >
                      <div class="stat-details">
                        <div class="stat-details__number">
                          {{ quote.statistic.number }}
                        </div>
                        <div class="stat-details__subtext">
                          {{ quote.statistic.subtext }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </template>
      <TheSubFooter nextRoute="/financials" />
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TheSubFooter from '@/components/footer/TheSubFooter';

export default {
  name: 'StrongLegalDefense',
  components: {
    DefaultPage,
    TheSubFooter
  }
};
</script>
